function normalizeBase(url) {
  if (url == null || url === '') return '';
  return String(url).replace(/\/$/, '');
}

function getApiBase() {
  const env = process.env.NODE_ENV;
  const developmentUrl = process.env.REACT_APP_API_URL_DEVELOPMENT || process.env.REACT_APP_API_URL || '';
  const productionUrl = process.env.REACT_APP_API_URL_PRODUCTION || process.env.REACT_APP_API_URL || '';
  return normalizeBase(env === 'production' ? productionUrl : developmentUrl);
}

export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBase()}${p}`;
}

export const securityConfig = {
  turnstileSiteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || '',
};
